define('drops/normalDistribution/normalDistribution',["jquery", "when", "lq", "lq/drop", "lq/cssutil", "drops/normalDistribution/normalDistributionDefaults"], function (
    $,
    when,
    lq,
    Drop,
    cssUtil,
    dropDefaults
) {
    "use strict";

    var d3 = null;
    var c3 = null;

    var NormalDistribution = function (options) {
        Drop.call(this, $("<div class = 'normal-distribution-drop'/>"), dropDefaults, options);

        this.$chart = $("<div>").appendTo(this.$element);
    };

    Drop.extend(NormalDistribution);

    NormalDistribution.typeName = "NormalDistribution";

    NormalDistribution.prototype.preRender = function () {
        this.piping.visibility.apply(this);

        var deferred = when.defer();
        require(["d3", "c3"], function (lazyLoadedD3, lazyLoadedC3) {
            cssUtil.requireCss("c3.min.css");
            cssUtil.requireCss("drops/normalDistribution/normalDistribution.css");

            d3 = lazyLoadedD3;
            c3 = lazyLoadedC3;
            deferred.resolve();
        });

        this.applyPosition();

        var self = this;

        // always needed, but can be empty
        this.piping.datasources.registerDatasourceListener(
            this.data.chosenValueDataSource,
            function (chosen) {
                self.chosenData = chosen;
                self.checkUpdate();
            }
        );

        // numeric approach
        if (self.data.methodType === "numericDataset"){
            this.piping.datasources.registerDatasourceListener(
                this.data.numericDatasetDataSource,
                function (numeric) {
                    self.numericData = numeric;
                    self.checkUpdate();
                }
            );
        }

        // parametric approach
        if (self.data.methodType === "meanAndSTD"){
            this.piping.datasources.registerDatasourceListener(
                this.data.meanAndStdDataSource,
                function (meanAndStd) {
                    self.meanAndStdData = meanAndStd;
                    self.checkUpdate();
                }
            );
        }

        return deferred.promise;
    };

    NormalDistribution.prototype.postRender = function () {

        this.generateEmptyChart();

    };

    var calcMean = function (arr) {
        var sum = arr.reduce(function (acc, val) {
            return acc + val;
        }, 0);
        return sum / arr.length;
    };
    var calcStandardDeviation = function (arr, sample) {
        var avg = calcMean(arr);
        var squaredDiffs = arr.map(function (val) {
            return Math.pow(val - avg, 2);
        });
        var avgSquaredDiffs;
        if (sample) {
            avgSquaredDiffs = calcMean(squaredDiffs) * (arr.length / (arr.length - 1));
        } else {
            avgSquaredDiffs = calcMean(squaredDiffs);
        }
        return Math.sqrt(avgSquaredDiffs);
    };
    var calcPdf = function (x, mean, stdDeviation) {
        var coefficient = 1 / (stdDeviation * Math.sqrt(2 * Math.PI));
        var exponent = -Math.pow(x - mean, 2) / (2 * Math.pow(stdDeviation, 2));
        return 100 * coefficient * Math.exp(exponent); // in percentages
    };
    var calcCdf = function (x, mean, std) {
        var x = (x - mean) / std;
        var t = 1 / (1 + 0.2315419 * Math.abs(x));
        var d = 0.3989423 * Math.exp((-x * x) / 2);
        var prob = d * t * (0.3193815 + t * (-0.3565638 + t * (1.781478 + t * (-1.821256 + t * 1.330274))));
        if (x > 0) prob = 1 - prob;
        return 100 * prob; // in percentages
    };
var arrayRange = function (start, stop, count) {
        var step = (stop - start) / count;
        return Array.from({ length: count + 1 }, function (value, index) {
            return start + index * step;
        });
    };
var generateDataPointsForRange = function (start, end, mean, std, numPoints) {
        var xRange = arrayRange(start, end, numPoints);
        return xRange.map(function (x) {
            return calcPdf(x, mean, std);
        });
    };
    var cleanArray = function (arr, x) {
        arr.sort(function (a, b) {
            return a - b;
        });
        var cleanedArray = [arr[0]];

        // lower values get priority
        for (var i = 1; i < arr.length; i++) {
            if (arr[i] - cleanedArray[cleanedArray.length - 1] >= x) {
                cleanedArray.push(arr[i]);
            }
        }

        return cleanedArray;
    };
    NormalDistribution.prototype.generateTooltipPercentile = function (val, mean, std){
        var self = this;
        var tooltipHtml = "";
        var val = val.toFixed(self.data.axisXPrecision)
        var percentile = calcCdf(val, mean, std);
        if (percentile > 50) percentile = "Top " + (100 - percentile).toFixed(2) + "%";
        else percentile = "Bottom " + percentile.toFixed(2) + "%";
        tooltipHtml += "<tr><td> " + ((self.showXAxis && self.data.axisXLabel) || self.valueColumn || "Value") + " </td><td>" + val + "</td></tr>";
        tooltipHtml += '<tr><td colspan="2"><b>' + percentile + "</b></td></tr>";
        return tooltipHtml
    }

    NormalDistribution.prototype.update = function () {
        var self = this;

        var mean, std;

        if (self.data.methodType === "numericDataset") {
            var population = [];
            if (self.numericData.totalResults) {
                var keys = Object.keys(self.numericData.outputs);
                if (keys.length > 1) return self.generateEmptyChart("Too many columns in numeric dataset.");
                var arrKey = keys[0];
                population = self.numericData.results.map(function (obj) {
                    return obj[arrKey];
                });

                mean = calcMean(population);
                std = calcStandardDeviation(population, !self.data.numericIsPopulation);
            }
            if (!population.length) return self.generateEmptyChart(); // have to handle this separately
        } else {
            var datarow = self.meanAndStdData.results[0]
            mean = datarow[self.data.meanDataSourceColumn]
            std = datarow[self.data.stdDataSourceColumn]
        }

        var chosenValues = [];
        if (self.data.chosenValueDataType == "labeled") {
            var errors = "";
            if (!self.data.valuesDataLabelColumn) {
                errors += "No label column selected.\n";
            }
            if (!self.data.valuesDataValueColumn) {
                errors += "No value column selected.\n";
            }
            if (errors) return self.generateEmptyChart(errors);

            self.labelColumn = self.data.valuesDataLabelColumn;
            self.valueColumn = self.data.valuesDataValueColumn;
            self.chosenValueNamePairs = self.chosenData.results.reduce(function (acc, obj) {
                acc[obj[self.labelColumn]] = obj[self.valueColumn];
                return acc;
            }, {});
            chosenValues = Object.values(self.chosenValueNamePairs);
        } else {
            self.chosenData = self.chosenData || {
                outputs: [],
                results: [],
                totalResults: 0,
            };
            if (self.chosenData.totalResults) {
                var keys = Object.keys(self.chosenData.outputs)
                if (keys.length > 1)
                    return self.generateEmptyChart("Too many columns in chosen dataset.");
                var chosenKey = Object.keys(self.chosenData.outputs)[0]
                chosenValues = self.chosenData.results.map(function (obj) {
                    return obj[chosenKey];
                });
            }
        }

        var height = calcPdf(mean, mean, std);

        var start = mean - 3 * std;
        var end = mean + 3 * std;
        var deviationFragments = 35;

        var xFarBelowAvg = arrayRange(start, mean - 2 * std, Math.floor(deviationFragments / 6));
        var farBelowAvg = generateDataPointsForRange(start, mean - 2 * std, mean, std, Math.floor(deviationFragments / 6));

        var xBelowAvg = arrayRange(mean - 2 * std, mean - std, Math.floor(deviationFragments / 6));
        var belowAvg = generateDataPointsForRange(mean - 2 * std, mean - std, mean, std, Math.floor(deviationFragments / 6));

        var xAvg = arrayRange(mean - std, mean + std, Math.floor(deviationFragments / 3));
        var avg = generateDataPointsForRange(mean - std, mean + std, mean, std, Math.floor(deviationFragments / 3));

        var xAboveAvg = arrayRange(mean + std, mean + 2 * std, Math.floor(deviationFragments / 6));
        var aboveAvg = generateDataPointsForRange(mean + std, mean + 2 * std, mean, std, Math.floor(deviationFragments / 6));

        var xFarAboveAvg = arrayRange(mean + 2 * std, end, Math.floor(deviationFragments / 6));
        var farAboveAvg = generateDataPointsForRange(mean + 2 * std, end, mean, std, Math.floor(deviationFragments / 6));

        var chartSettings = {
            bindto: self.$chart[0],
            size: {
                height: this.data.top != null || this.data.bottom != null ? undefined : self.data.size.y,
            },
            transition: {
                duration: 0,
            },
            data: {
                xs: {
                    farBelowAverage: "xfba",
                    belowAverage: "xba",
                    average: "xa",
                    aboveAverage: "xaa",
                    farAboveAverage: "xfaa",
                },
                columns: [
                    ["xfba", ...xFarBelowAvg],
                    ["farBelowAverage", ...farBelowAvg],
                    ["xba", ...xBelowAvg],
                    ["belowAverage", ...belowAvg],
                    ["xa", ...xAvg],
                    ["average", ...avg],
                    ["xaa", ...xAboveAvg],
                    ["aboveAverage", ...aboveAvg],
                    ["xfaa", ...xFarAboveAvg],
                    ["farAboveAverage", ...farAboveAvg],
                ],
                types: {
                    farBelowAverage: "area-spline",
                    belowAverage: "area-spline",
                    average: "area-spline",
                    aboveAverage: "area-spline",
                    farAboveAverage: "area-spline",
                },
                names: {
                    farBelowAverage: (self.data.customLabelNames && self.data.lowestLabel) || dropDefaults.data.lowestLabel,
                    belowAverage: (self.data.customLabelNames && self.data.lowerLabel) || dropDefaults.data.lowerLabel,
                    average: (self.data.customLabelNames && self.data.averageLabel) || dropDefaults.data.averageLabel,
                    aboveAverage: (self.data.customLabelNames && self.data.higherLabel) || dropDefaults.data.higherLabel,
                    farAboveAverage: (self.data.customLabelNames && self.data.highestLabel) || dropDefaults.data.highestLabel,
                },
                colors: {
                    farBelowAverage: (self.data.customColors && self.data.lowestColor) || dropDefaults.data.lowestColor,
                    belowAverage: (self.data.customColors && self.data.lowerColor) || dropDefaults.data.lowerColor,
                    average: (self.data.customColors && self.data.averageColor) || dropDefaults.data.averageColor,
                    aboveAverage: (self.data.customColors && self.data.higherColor) || dropDefaults.data.higherColor,
                    farAboveAverage: (self.data.customColors && self.data.highestColor) || dropDefaults.data.highestColor,
                },
            },
            grid: {
                x: {
                    show: self.data.showGridX,
                },
                y: {
                    show: self.data.showGridY,
                },
            },
            bar: {
                width: self.data.barWidth,
            },
            tooltip: {
                show: self.data.showTooltip,
                contents: function (d) {
                    var tooltipHtml = '<div class="c3-tooltip-container">';
                    tooltipHtml += '<table class="c3-tooltip">';
                    tooltipHtml += "<tbody>";

                    var zoomDomain = self.chart ? self.chart.zoom() : [-3 * sigma, 3 * sigma];
                    var joinThreshold = (zoomDomain[1] - zoomDomain[0]) / 80;

                    var count = 0;
                    if (self.chosenPoints) {
                        if (self.data.chosenValueDataType == "unlabeled") {
                            var appendAfterCount = "";
                            self.chosenPoints.toSorted().forEach(function (p) {
                                if (Math.abs(p - d[0].x) < joinThreshold) {
                                    if (count < self.data.maxTooltips)
                                        appendAfterCount += self.generateTooltipPercentile(p, mean, std)
                                    count++;
                                }
                            });
                            if (appendAfterCount) {
                                tooltipHtml += '<tr><th colspan="2">' + self.data.chosenLabel + "</th></tr>";
                                if (count > 1) tooltipHtml += "<tr><th> Count: </th><th>" + count + "</th></tr>";
                                tooltipHtml += appendAfterCount;
                            }
                        } else {
                            for (var key in self.chosenValueNamePairs) {
                                var val = self.chosenValueNamePairs[key];
                                if (Math.abs(val - d[0].x) < joinThreshold) {
                                    if (count < self.data.maxTooltips) {
                                        tooltipHtml += '<tr><th colspan="2"><b>' + key + "</b></th></tr>";
                                        tooltipHtml += self.generateTooltipPercentile(val, mean, std)
                                    }
                                    count++;
                                }
                            }
                        }
                    }
                    if (!count) tooltipHtml += self.generateTooltipPercentile(d[0].x, mean, std)
                    else if (count > self.data.maxTooltips) tooltipHtml += '<tr><td colspan="2"><b> . . . </b></td></tr>';

                    tooltipHtml += "</tbody>";
                    tooltipHtml += "</table>";
                    tooltipHtml += "</div>";
                    return tooltipHtml;
                },
            },
            axis: {
                x: {
                    show: self.data.showXAxis,
                    label: {
                        text: self.data.axisXLabel,
                        position: self.data.axisXLabelPosition,
                    },
                    tick: {
                        format: d3.format('.' + self.data.axisXPrecision + 'f'),
                        values: [
                            ...arrayRange(
                                self.data.axisXLimit && self.data.axisXLimitMin ? self.data.axisXLimitMin : start,
                                self.data.axisXLimit && self.data.axisXLimitMax ? self.data.axisXLimitMax : end,
                                6).map(function (n) {
                                return n
                            }),
                        ],
                        multiline: true,
                    },
                    min: self.data.axisXLimit ? self.data.axisXLimitMin : undefined,
                    max: self.data.axisXLimit ? self.data.axisXLimitMax : undefined
                },
                y: {
                    show: self.data.showYAxis,
                    label: {
                        text: self.data.axisYLabel,
                        position: self.data.axisYLabelPosition,
                    },
                    tick: {
                        format: d3.format('.' + self.data.axisYPrecision + 'f'),
                        values: [
                            0,
                            ...arrayRange(start + std, mean, 2).map(function (n) {
                                return calcPdf(n, mean, std)
                            }),
                        ],
                    },
                },
            },
            point: {
                r: self.data.valueRadius,
            },
            legend: {
                show: false, // legends are added later for modularity
                position: self.data.legendPosition
            },
            padding: {
                right: 5 + 5 * self.data.axisXPrecision, // make sure largest x value doens't get cut off
            },
            zoom: {
                enabled: self.data.enableZoom,
            },
        };

        if (self.data.axisXRemovePadding){
            chartSettings.axis.x.padding = {
                left: 0,
                right: 0,
            }
        }

        // render only the curve if no value was chosen
        if (chosenValues.length) {
            self.chosenPoints = chosenValues;
            var chosenPdfs = self.chosenPoints.map(function (point) {
                return calcPdf(point, mean, std).toFixed(self.data.axisYPrecision);
            });

            chartSettings.data.xs.chosenPoints = "xChosen";
            chartSettings.data.columns.push(["xChosen", ...self.chosenPoints]);
            chartSettings.data.columns.push(["chosenPoints", ...chosenPdfs]);
            chartSettings.data.types.chosenPoints = "scatter";

            if (self.data.showChosenBars) {
                chartSettings.data.xs.chosenPointBars = "xChosen";
                chartSettings.data.columns.push(["chosenPointBars", ...Array(self.chosenPoints.length).fill(height)]);
                chartSettings.data.types.chosenPointBars = "bar";
                chartSettings.data.colors.chosenPointBars = (self.data.customColors && self.data.chosenColor) || self.data.chosenColor;
            }

            chartSettings.data.names.chosenPoints = (self.data.customLabelNames && self.data.chosenLabel) || dropDefaults.data.chosenLabel;
            chartSettings.data.colors.chosenPoints = (self.data.customColors && self.data.chosenColor) || self.data.chosenColor;

            var chosenPointsPlucked = cleanArray(self.chosenPoints, std / 3);
            chartSettings.axis.x.tick.values = chartSettings.axis.x.tick.values.filter(function (n) {
                return !chosenPointsPlucked.some(function (cp) {
                    return Math.abs(cp - n) < std / 3;
                });
            });
            Array.prototype.push.call(chartSettings.axis.x.tick.values, ...chosenPointsPlucked);

            var chosenPdfsPlucked = cleanArray(chosenPdfs, height / 18);
            chartSettings.axis.y.tick.values = chartSettings.axis.y.tick.values.filter(function (n) {
                return !chosenPdfsPlucked.some(function (cp) {
                    return Math.abs(cp - n) < height / 18;
                });
            });
            Array.prototype.push.call(chartSettings.axis.y.tick.values, ...chosenPdfs);
            chartSettings.axis.y.tick.values = cleanArray(chartSettings.axis.y.tick.values, height / 18);
        }

        if (self.chart) {
            self.chart.destroy();
        }
        self.chart = c3.generate(chartSettings);
        if (self.data.showLegend) {
            var toShow = [];
            if (self.data.showChosenLegend && self.chosenPoints) toShow.push("chosenPoints");
            if (self.data.showLowestLegend) toShow.push("farBelowAverage");
            if (self.data.showLowerLegend) toShow.push("belowAverage");
            if (self.data.showAverageLegend) toShow.push("average");
            if (self.data.showHigherLegend) toShow.push("aboveAverage");
            if (self.data.showHighestLegend) toShow.push("farAboveAverage");
            self.chart.legend.show(toShow);

        }
    };

    NormalDistribution.prototype.generateEmptyChart = function (text) {
        if (this.chart) {
            this.chart.destroy();
        }
        this.chart = c3.generate({
            bindto: this.$chart[0],
            data: {
                columns: [],
                type: "line",
                empty: {
                    label: {
                        text: text || this.data.emptyText,
                    },
                },
            },
        });
    };

    NormalDistribution.prototype.checkUpdate = function () {
        if (this.chosenData){
            if (this.data.methodType === "numericDataset" && this.numericData) {
                this.update()
            } else
            if (this.data.methodType === "meanAndSTD" && this.meanAndStdData) {
                this.update()
            }
        }
    }

    return NormalDistribution;
});

